export const ACTIONS = {
  VISIBILITY: 'loader/change_visibility',
};

export const loaderSetVisible = isVisible =>
  dispatch => dispatch({ type: ACTIONS.VISIBILITY, payload: isVisible });
